<template>
  <!-- id : contents : (S) -->
  <div id="contents" class="st-main">
    <div
      class="popup-wrap"
      :style="popupStyle(data)"
      v-for="(data, idx) in popup"
      :key="data.popupId"
    >
      <div class="pop-inner-box">
        <div class="pop-body-box">
          <!-- 2021-01-05 add -->
          <div class="popup-close">
            <a
              href="javascript:;"
              class="pop-btn-cloe"
              @click="closePopup(data)"
              >닫기</a
            >
          </div>
          <!-- 2021-01-05 add -->
          <div v-if="data.url">
            <div
              @click="popupGoLink(data.url, data.urlTarget)"
              style="cursor: pointer"
              :style="popupContentStyle(data)"
              v-html="data.contents"
            ></div>
          </div>
          <div v-if="data.url === ''">
            <div :style="popupContentStyle(data)" v-html="data.contents"></div>
          </div>
        </div>
        <div class="pop-btm-box">
          <input
            type="checkbox"
            class="pop-chk"
            :id="'pop-' + idx"
            v-model="hidePopup"
            :value="data.popupId"
          /><label :for="'pop-' + idx">하루동안 보지않기</label>
          <a href="javascript:;" class="pop-btn-cloe" @click="closePopup(data)"
            >닫기</a
          >
        </div>
      </div>
    </div>

    <!-- class : content-wrap : (S) -->
    <section class="content-wrap st-main">
      <!-- class : main-wrap (S) -->
      <div class="main-wrap">
        <div class="mb-main-box">
          <div class="logo-box"><h1 class="logo"></h1></div>
          <!-- <div class="main-title-box">
            <div class="tit">전자사랑모임</div>
            <div class="txt">
              안녕하세요, {{ this.$store.state.user.username }}님 !
            </div>
          </div> -->
        </div>
        <!-- class : main-vi-wrap (S) -->
        <div class="main-vi-wrap st-main">
          <div class="main-vi-box">
            <div class="main-quick-box">
              <a href="/my/inquiry" class="btn-quick-box">
                <i class="st-01"></i>
                <span>1:1문의</span>
              </a>
              <a href="/member/2?upper=426&menu=441" class="btn-quick-box">
                <i class="st-02"></i>
                <span>연간일정</span>
              </a>
              <a href="/my/meetList" class="btn-quick-box">
                <i class="st-03"></i>
                <span>모임신청<br />내역</span>
              </a>
            </div>
            <div
              class="swiper-button-next custom-next"
              @click="onClickCurrentPage(false, '')"
            ></div>
            <div
              class="swiper-button-prev custom-prev"
              @click="onClickCurrentPage(true, '')"
            ></div>
            <slider
              ref="slider"
              class="vi-item-box"
              style="width: 100%"
              :options="options"
            >
              <slideritem
                v-for="(data, i) in visualMain"
                class="swiper-slide"
                :key="`mainUrls-${i}`"
              >
                <div
                  class="img-box"
                  :style="`width:100%;background: url(/attachment/banner/${data.bannerImage}) center top no-repeat;background-size: cover`"
                  @click="onClickBanner(data.url)"
                ></div>

                <div class="sp-page-box">
                  <div class="swiper-pagination"></div>
                </div>
                <div class="txt-box">
                  <div class="inner-box">
                    <span class="">{{ data.title }}</span
                    ><em>{{ data.alt }}</em>
                  </div>
                </div>
              </slideritem>
            </slider>
          </div>
        </div>
        <!-- class : main-vi-wrap (E) -->
        <div class="main-title-mb-box">
          <div class="tit">전자사랑모임</div>
          <div class="txt">
            안녕하세요, {{ this.$store.state.user.username }}님 !
          </div>
        </div>

        <div class="main-quick-mb-box">
          <a href="/my/inquiry" class="btn-quick-box">
            <i class="st-01"></i>
            <span>1:1문의</span>
          </a>
          <a href="/board/566?upper=431&menu=487" class="btn-quick-box">
            <i class="st-02"></i>
            <span>공지사항</span>
          </a>
          <a href="/board/532891?upper=431&menu=539593" class="btn-quick-box">
            <i class="st-03"></i>
            <span>행사소식</span>
          </a>
          <a href="/board/567?upper=431&menu=489" class="btn-quick-box">
            <i class="st-04"></i>
            <span>경조사</span>
          </a>
        </div>

        <div class="main-third-mb-box">
          <div class="inner-base-box">
            <div class="main-h2">혜택 안내</div>
            <a
              class="item-box st-01"
              href="https://jfamilymall.com/"
              target="_blank"
              title="전자사랑몰 새창으로"
            >
              <div class="tit">전자사랑몰</div>
              <div class="txt">삼성전자/생활용품 할인</div>
            </a>
            <a
              href="https://eclub.hanatour.com/"
              target="_blank"
              class="item-box st-02"
            >
              <div class="tit">하나투어</div>
              <div class="txt">국/내외 여행 할인</div>
            </a>
            <a
              href="/board/566?upper=431&menu=487&c=detail&at=350404&fr=main"
              class="item-box st-03"
            >
              <div class="tit">우리원/하트스캔</div>
              <div class="txt">건강검진 할인</div>
            </a>
            <a
              class="item-box st-04"
              href="/board/567?upper=431&menu=489&c=detail&at=25420&g"
            >
              <div class="tit">경조사</div>
              <div class="txt">경조사 신청하기</div>
            </a>
            <a href="/page/3250?upper=425&menu=433" class="item-box st-more">
              <div class="txt-more">전체보기</div>
              <div class="icon"></div>
            </a>
          </div>
        </div>

        <div class="main-first-box">
          <div class="inner-base-box">
            <div class="main-h2">e-CLUB 소식</div>
            <div class="main-notice-tab-box">
              <div class="tab">
                <button
                  class="tablinks"
                  :class="{ active: activeTab === 'notice' }"
                  @click="setActiveTab('notice')"
                >
                  공지사항
                </button>
                <button
                  class="tablinks"
                  :class="{ active: activeTab === 'event' }"
                  @click="setActiveTab('event')"
                >
                  행사소식
                </button>
                <button
                  class="tablinks"
                  :class="{ active: activeTab === 'good' }"
                  @click="setActiveTab('good')"
                >
                  경조사
                </button>
                <div class="btn-more">
                  <a :href="allViewLink"><span>전체보기</span><i></i></a>
                </div>
              </div>

              <div v-if="activeTab === 'notice'" class="tabcontent">
                <ul>
                  <li v-for="article in notice" :key="article.articleId">
                    <router-link
                      :to="`/board/566?upper=431&menu=487&c=detail&at=${article.articleId}&fr=main`"
                      class=""
                    >
                      <div class="dg-fnt-mont date">
                        {{ formatDate(article.createdAt) }}
                      </div>
                      <div class="tit">{{ article.title }}</div>
                    </router-link>
                  </li>
                </ul>
              </div>

              <div v-if="activeTab === 'event'" class="tabcontent">
                <ul>
                  <li v-for="article in event" :key="article.articleId">
                    <router-link
                      :to="`/board/532891?upper=431&menu=539593&c=detail&at=${article.articleId}&fr=main`"
                      class=""
                    >
                      <div class="dg-fnt-mont date">
                        {{ formatDate(article.createdAt) }}
                      </div>
                      <div class="tit">{{ article.title }}</div>
                    </router-link>
                  </li>
                </ul>
              </div>
              <div v-if="activeTab === 'good'" class="tabcontent">
                <ul>
                  <li v-for="article in good" :key="article.articleId">
                    <router-link
                      :to="`/board/567?upper=431&menu=489&c=detail&at=${article.articleId}&fr=main`"
                      class=""
                    >
                      <div class="dg-fnt-mont date">
                        {{ formatDate(article.createdAt) }}
                      </div>
                      <div class="tit">{{ article.title }}</div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>

            <div class="main-banner-box">
              <a
                href="https://news.samsung.com/kr/"
                target="_blank"
                class="main-more-2-btn"
                ><div class="main-banner-img"></div
              ></a>

              <!-- <slider
                ref="slider"
                class="vi-item-box"
                style="width: 100%"
                :options="options"
              >
                <slideritem
                  v-for="(data, i) in noticeBanners"
                  class="swiper-slide"
                  :key="`mainUrls-${i}`"
                >
                  <div
                    class="img-box"
                    :style="`width:100%;background: url(/attachment/banner/${data.bannerImage}) center top no-repeat;background-size: cover`"
                    @click="onClickBanner(data.url)"
                  ></div>
                </slideritem>
              </slider> -->
            </div>
          </div>
        </div>
        <div class="inner-base-box">
          <div class="main-notice-btn-more-mb">
            <a href="/community/0?upper=431&menu=487"
              ><span>전체보기</span><i></i
            ></a>
          </div>
        </div>

        <div class="main-third-box">
          <div class="inner-base-box">
            <div class="main-h2">혜택 안내</div>
            <div class="inner-list-box">
              <a
                class="item-box st-01"
                href="https://jfamilymall.com/"
                target="_blank"
                title="전자사랑몰 새창으로"
              >
                <div class="tit">전자사랑몰</div>
                <div class="txt">삼성전자/생활용품 할인</div>
              </a>
              <a
                href="https://eclub.hanatour.com/"
                target="_blank"
                class="item-box st-02"
              >
                <div class="tit">하나투어</div>
                <div class="txt">국/내외 여행 할인</div>
              </a>
              <!-- <a
                href="https://www.wwh.co.kr/"
                target="_blank"
                class="item-box st-03"
              > -->
              <a
                href="/board/566?upper=431&menu=487&c=detail&at=350404&fr=main"
                class="item-box st-03"
              >
                <div class="tit">우리원/하트스캔</div>
                <div class="txt">건강검진 할인</div>
              </a>
              <a
                class="item-box st-04"
                href="/board/567?upper=431&menu=489&c=detail&at=25420&g"
              >
                <div class="tit">경조사</div>
                <div class="txt">경조사 신청하기</div>
              </a>
              <a href="/page/3250?upper=425&menu=433" class="item-box st-more">
                <div class="txt-more">전체보기</div>
                <div class="icon"></div>
              </a>
            </div>
          </div>
        </div>
        <div class="main-fourth-box">
          <div class="inner-base-box">
            <div class="photo-box">
              <div class="tit-box">
                <div class="main-h2">포토갤러리</div>
                <div class="btn-more">
                  <router-link
                    to="/board/568?upper=431&menu=490"
                    class="txt-more"
                    ><span>전체보기</span><i class="more"></i
                  ></router-link>
                </div>
              </div>
              <ul class="main-photo-box">
                <li v-for="photo in photos" :key="photo.articleId">
                  <a
                    :href="`/board/568?upper=431&menu=490&c=detail&at=${photo.articleId}&fr=main`"
                    class=""
                  >
                    <div class="img-s">
                      <v-img
                        :src="
                          photo.mainImage.fileServerName
                            ? `/attachment/board/${photo.boardId}/${photo.mainImage.thumbnail}`
                            : '/photo_default.jpg'
                        "
                        v-on:error.once="
                          photo.mainImage.thumbnail = '/photo_default.jpg'
                        "
                        width="285"
                        height="214"
                        style="border-radius: 16px"
                      />
                    </div>
                    <div class="tit-s ellipsis">{{ photo.title }}</div>
                    <div class="dg-fnt-mont date">
                      {{ formatDate(photo.createdAt) }}
                    </div>
                  </a>
                </li>
              </ul>
            </div>

            <div class="main-notice-btn-more-mb">
              <a href="/board/568?upper=431&menu=490"
                ><span>전체보기</span><i></i
              ></a>
            </div>
          </div>
        </div>

        <div class="main-btm-box">
          <div class="inner-base-box">
            <div class="main-btm-banner-box">
              <div class="birth-box">
                <p class="main-h2">생일을 축하해주세요!</p>
                <div class="main-slide-02">
                  <slider
                    ref="slider2"
                    class="vi-item-box swiper-wrapper"
                    :options="options2"
                  >
                    <slideritem
                      v-for="(data, i) in memberImageUrls"
                      style="width: 140px"
                      class="swiper-slide"
                      :key="`membImg-${i}`"
                    >
                      <div class="inner-box">
                        <img
                          class="member-list-box"
                          :src="getMemberPhoto(data.photoFile)"
                          :class="{ open: showMemberDetail(i) }"
                          @click="showMemberDetailOpen(i)"
                          @error="
                            (e) =>
                              (e.target.src = require('@/assets/front/images/icon/member.jpg'))
                          "
                        />
                        <div class="txt-box">
                          <div class="date-box">
                            <span class="date dg-fnt-mont">{{
                              formatBirth(data.birthDate)
                            }}</span>
                            <em>{{ data.lunarBirth ? '음력' : '양력' }}</em>
                          </div>
                          <span class="name">
                            <div
                              class="send-msg-menu-box"
                              :class="{ open: showMemberDetail(i) }"
                              @click="showMemberDetailOpen(i)"
                            >
                              <!-- open 클래스 추가 시 버튼 노출 -->
                              <a href="javascript:;" class="btnSendMenu"
                                >{{ data.name }} 님</a
                              >
                              <div
                                class="btn-list-box"
                                style="margin-left: -48px"
                              >
                                <a
                                  href="javascript:;"
                                  class="btnPeopleDtlOver"
                                  @click="onClickUser(data.userId, 'detail')"
                                  >회원 정보</a
                                >
                                <a
                                  href="javascript:;"
                                  class="btnMemoSendOver"
                                  @click="onClickUser(data.userId, 'message')"
                                  >쪽지보내기</a
                                >
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </slideritem>
                  </slider>
                  <!-- Add Navigation -->
                  <div
                    class="swiper-button-prev"
                    @click="onClickCurrentPage(true, '2')"
                  ></div>
                  <div
                    class="swiper-button-next"
                    @click="onClickCurrentPage(false, '2')"
                  ></div>
                </div>
              </div>
            </div>
            <div class="main-btm-contact-box">
              <div class="tit-box">Contact</div>
              <div class="txt-box">
                <div class="tel">
                  <i class="icon-tel"></i> <span>02-558-3401, 3</span>
                </div>
                <div class="mail">
                  <i class="icon-mail"></i> <span>eclub@eclub.or.kr</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="main-btm-banner-wrap">
          <div class="main-banner-box main-slide-03">
            <slider
              ref="slider3"
              class="vi-item-box"
              style="width: 100%"
              :options="options3"
            >
              <slideritem
                v-for="(banner, i) in banners"
                class="swiper-slide"
                :key="`mainUrls-${i}`"
              >
                <img
                  v-if="banner.activated"
                  :src="`/attachment/banner/${banner.bannerImage}`"
                  @click="onClickBanner(banner.url)"
                />
                <div class="sp-page-box">
                  <div class="swiper-pagination"></div>
                </div>
              </slideritem>
            </slider>
            <!-- Add Navigation -->
            <div
              class="swiper-button-prev"
              @click="onClickCurrentPage(true, '3')"
            ></div>
            <div
              class="swiper-button-next"
              @click="onClickCurrentPage(false, '3')"
            ></div>
          </div>
        </div>
      </div>
      <!-- class : main-wrap (E) -->

      <CommonPopup
        v-if="memberList"
        :tap="popupTab"
        :isOpen="isOpen"
        :userId="userId"
        @click:bgDimClose="popupMemberList"
      ></CommonPopup>
    </section>
    <!-- class : content-wrap : (E) -->
  </div>
  <!-- id : contents : (E) -->
</template>
<style>
.swiper-container-horizontal > .slider-pagination-bullets {
  bottom: 24px !important;
}
.swiper-container-horizontal > * > .slider-pagination-bullet {
  background: rgba(255, 255, 255) !important;
  opacity: 0.6 !important;
  margin: 0 2px !important;
}
.swiper-container-horizontal > * > .slider-pagination-bullet-active {
  opacity: 1 !important;
  border-radius: 4px !important;
  width: 19px !important;
}
.slider-item {
  text-align: none !important;
  font-size: 16px !important;
  text-align: unset !important;
  justify-content: unset !important;
}
.slider-container {
  overflow: unset !important;
}
</style>
<script>
import { slider, slideritem } from 'vue-concise-slider';
import articleApi from '@/api/ArticleApi';
import moment from 'moment';
import BannerApi from '@/api/BannerApi';
import UserApi from '@/api/UserApi';
import CommonPopup from '@/views/include/common_popoup';
import PopupApi from '@/api/PopupApi';

export default {
  name: 'main',
  components: {
    slider,
    slideritem,
    CommonPopup,
  },
  data() {
    return {
      photos: [],
      banners: [],
      hidePopup: [],

      memberList: false,
      popupTab: 'detail',
      userId: null,
      memberOpen: false,
      rowIndex: -1,
      options: {
        pagination: true,
        thresholdDistance: 100, // Sliding distance threshold
        thresholdTime: 300, // Sliding time threshold decision
        grabCursor: true, // Scratch style
        speed: 300, // Sliding speed
        loop: true,
        autoplay: '5000',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      options2: {
        currentPage: 0,
        pagination: false,
        loopedSlides: 3,
        thresholdDistance: 100, // Sliding distance threshold
        thresholdTime: 300, // Sliding time threshold decision
        grabCursor: true, // Scratch style
        speed: 300, // Sliding speed
        loop: false,
      },
      option2index: 0,
      options3: {
        pagination: true,
        loopedSlides: 1,
        thresholdDistance: 100, // Sliding distance threshold
        thresholdTime: 300, // Sliding time threshold decision
        grabCursor: true, // Scratch style
        speed: 300, // Sliding speed
        loop: true,
        autoplay: '3000',
      },
      visualMain: [],
      memberImageUrls: [],
      noticeBanners: [],

      notice: [],
      event: [],
      goood: [],
      popup: [],
      activeTab: 'notice',
      allViewLink: '/board/566?upper=431&menu=487',
    };
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isOpen(e) {
      if (!e) {
        this.memberList = false;
      }
    },
  },
  created() {
    this.getPopup();
    this.getContents();
    this.getBanner();
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab; // 클릭한 탭으로 activeTab 변경
      if (tab === 'notice') this.allViewLink = '/board/566?upper=431&menu=487';
      if (tab === 'event')
        this.allViewLink = '/board/532891?upper=431&menu=539593';
      if (tab === 'good') this.allViewLink = '/board/567?upper=431&menu=489';
    },
    formatBirth(val) {
      return moment(val).format('MM.DD');
    },
    getContents() {
      let param = {
        size: 5,
      };
      articleApi.list(566, param).then((data) => {
        this.notice = data.content;
      });

      articleApi.list(532891, param).then((data) => {
        this.event = data.content;
      });

      articleApi.list(567, param).then((data) => {
        this.good = data.content;
      });

      param = {
        size: 4,
      };
      articleApi.list(568, param).then((data) => {
        this.photos = data.content;
      });
      param = {
        size: 5,
      };
      UserApi.birthUsers().then((data) => {
        this.memberImageUrls = data.content;
        this.memberImageUrls.sort(function (a, b) {
          return a.birthDate.substring(5) < b.birthDate.substring(5)
            ? -1
            : a.birthDate.substring(5) > b.birthDate.substring(5)
            ? 1
            : 0;
        });
        // this.memberImageUrls.forEach(m => console.log(m.birthDate.substring(5)))
      });
    },
    getBanner() {
      let params = { page: 1 };
      BannerApi.list('TYPE_HOME_VISUAL', params).then((data) => {
        this.visualMain = data.content.filter((d) => d.activated);
      });
      BannerApi.list('TYPE_HOME_MAIN', params).then((data) => {
        this.banners = data.content.filter((d) => d.activated);
      });
      BannerApi.list('TYPE_LOGIN', params).then((data) => {
        this.noticeBanners = data.content.filter((d) => d.activated);
      });
    },
    onClickCurrentPage(e, slideType) {
      //this.rowIndex = -1
      let move = e ? 'slidePre' : 'slideNext';
      if (slideType === '2') {
        if (e) {
          if (this.option2index > 0) {
            this.option2index = this.option2index - 1;
            this.$refs.slider2.$emit(move);
          }
        } else {
          if (this.option2index < this.memberImageUrls.length - 3) {
            this.option2index = this.option2index + 1;
            this.$refs.slider2.$emit(move);
          }
        }
      } else if (slideType === '3') {
        this.$refs.slider3.$emit(move);
      } else {
        this.$refs.slider.$emit(move);
      }
    },
    onSlide(e) {
      console.log('onSlide', e);
      //this.rowIndex = -1
    },

    showMemberDetail(idx) {
      if (this.rowIndex === idx) {
        return true;
      }
    },
    showMemberDetailOpen(idx) {
      let user = this.$store.state.user.userid;
      if (user == null || user == '') {
        return false;
      }

      this.memberOpen = false;
      if (this.rowIndex == idx) {
        this.memberOpen = !this.memberOpen;
        this.rowIndex = -1;
      } else {
        this.rowIndex = idx;
      }
    },
    onClickUser(userId, popStatus) {
      this.memberOpen = false;
      this.userId = userId;
      this.popupTab = popStatus;
      this.popupMemberList(true);
    },
    popupMemberList(e) {
      this.memberList = e;
      this.$emit('click:bgDim', this.memberList);
    },
    formatDate(value) {
      return moment(value).format('YYYY.MM.DD');
    },
    closePopup(val) {
      this.popup = this.popup.filter((d) => d !== val);

      this.hidePopup.forEach((d) => {
        if (d == val.popupId) {
          let date = new Date();
          date.setTime(date.getTime() + 1000 * 60 * 60 * 24 * 1); //1일
          document.cookie =
            'cookie_displayPopup_' +
            d +
            '=false;expires=' +
            date.toUTCString() +
            ';path=/';
        }
      });
    },
    getPopup() {
      PopupApi.list('main', { page: 1 }).then((data) => {
        this.popup = data.content
          .map(this.popupFilter)
          .filter((c) => c !== null);
      });
    },
    popupFilter(m) {
      if (!m.activated) {
        return null;
      }

      if (!m.always) {
        let moment = require('moment');
        let now = moment().format('YYYY-MM-DD HH:mm:ss');

        let start = '';
        let end = '';
        if (m.startTm == null) {
          start = moment(m.startDt).format('YYYY-MM-DD');
        } else {
          start = moment(m.startDt + 'T' + m.startTm).format(
            'YYYY-MM-DD HH:mm:ss'
          );
        }

        if (m.endTm == null) {
          end = moment(m.endDt).format('YYYY-MM-DD');
        } else {
          end = moment(m.endDt + 'T' + m.endTm).format('YYYY-MM-DD HH:mm:ss');
        }

        if (start > now || end < now) {
          return null;
        }
      }

      let search = 'cookie_displayPopup_' + m.popupId;
      let value = document.cookie.match('(^|;) ?' + search + '=([^;]*)(;|$)');
      if (value != null) {
        return null;
      }

      return {
        popupId: m.popupId,
        title: m.title,
        contents: m.contents,
        positionLeft: m.positionLeft,
        positionTop: m.positionTop,
        sizeHeight: m.sizeHeight,
        sizeWidth: m.sizeWidth,
        urlTarget: m.urlTarget,
        url: m.url,
        layer: m.layer,
      };
    },

    popupStyle(val) {
      //위치
      return 'left:' + val.positionLeft + 'px;top:' + val.positionTop + 'px';
    },
    popupContentStyle(val) {
      //크기
      return 'width:' + val.sizeWidth + 'px;height:' + val.sizeHeight + 'px';
    },
    onClickBanner(url) {
      if (url != null && url != '') {
        window.open(url, '', '');
      }
    },
    getMemberPhoto(photoFile) {
      if (photoFile == null) {
        return '../../../src/assets/front/images/icon/member.jpg';
      } else {
        return `/attachment/user/photo/${photoFile}`;
      }
    },
    popupGoLink(url, target) {
      if (target === '_blank') {
        window.open(url, '_blank');
      } else {
        // 다른 경우에는 현재 창에서 이동
        window.location.href = url;
      }
    },
  },
};
</script>
